import type {PlanUpdateModalProps} from './plan-update-modal'
import {PlanUpdateModal} from './plan-update-modal'

import {bff} from '../bff-hooks'
import {isOnNewPricingPlan} from '../helpers'
import {ChoosePlanContainer} from '../manage-plan/choose-plan-container'

export const PlanUpdateModalWrapper = (props: PlanUpdateModalProps) => {
    const {data: companyPlanSummary, isLoading} =
        bff.paywall.planUpdateModal.getCompanyPlanSummary.useQuery()

    if (isLoading) {
        return null
    }

    if (isOnNewPricingPlan(companyPlanSummary?.planType)) {
        return <PlanUpdateModal {...props} />
    }
    return <ChoosePlanContainer {...props} trackingOrigin={props.pageSection ?? props.pageOrigin} />
}
